/* global angular, $ */
angular.module('ua5App.calendar')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('calendar', {
            url: '/calendar/:date/',
            templateUrl: 'states/calendar/calendar.html',
            controller: 'CalendarCtrl',
            controllerAs: 'ctrl',
            params: {
                date: {
                    value: null,
                    squash: true
                }
            }/*,
            resolve: {
                pageDate: ['$stateParams', function($stateParams) {
                    var date = $stateParams.date ? $stateParams.date : false;
                    var dArr = date.split('-');
                    var dObj;
                    var dateObj;
                    if (!date || dArr.length < 3) {
                        console.log('bad');
                        return null;
                    }
                    dObj.year = parseInt(dArr[0], 10);
                    dObj.month = parseInt(dArr[1], 10);
                    dObj.day = parseInt(dArr[2], 10);
                    dateObj = new Date(dObj.year, dObj.month - 1, dObj.day);

                        console.log(dateObj);
                    return dateObj;
                }]
            }*/
        });
    }])
    .controller('CalendarCtrl', ['$scope', '$timeout', 'PostFactory', 'MetaFactory', /*'pageDate', */'$state', function($scope, $timeout, PostFactory, MetaFactory, /* pageDate, */$state) {

        // on opening a new calendar, it's always gonna go to 'today'
        var today = new Date();

        // slidedown calendar stuff
        var slidedown = {
            element: null,
            duration: 250,
            animating: false
        };

        $scope.currentDate = false;

        function changeURLDate() {
            var dateString = !$scope.currentDate ? '' : $scope.currentDate.year + '-' + $scope.currentDate.month + ($scope.currentDate.date ? '-' + $scope.currentDate.date : '');
            if ($state.current.name === 'calendar') {
                $state.transitionTo('calendar', {date: dateString}, {notify:false, reload:false});
            }
        }

        if ($state.params.date) {
            var date = $state.params.date;
            var dArr = date.split('-');
            var dateObj;
            if (date && dArr.length > 1) {
                var y = parseInt(dArr[0], 10),
                    m = parseInt(dArr[1], 10) - 1,
                    d = dArr[2] ? parseInt(dArr[2], 10) : false;

                // validate date
                if (!isNaN(y) && !isNaN(m) && !isNaN(d) && y > 0 && m > -1 && m < 12 && d > -2 && d < 32) {
                    dateObj = new Date(y, m, d);
                    dateObj = {year: y, month: m, date: d};
                    $scope.currentDate = dateObj;
                }
            }
            if (!$scope.currentDate) {
                $scope.currentDate = false;
                changeURLDate();
            }
        }

        MetaFactory.set({
            title: 'Calendar',
            description: 'General Events including Lectures, Exhibitions, Performances, Screenings, Workshops, Family Programs, Tours, and Alumni events.'
        });

        $scope.programFilters = [
            {
                name: 'All Programs',
                value: ''
            }
        ];

        $scope.eventTypeFilters = [
            {
                name: 'All Event Types',
                value: ''
            },
            {
                name: 'General',
                value: 'General'
            },
            {
                name: 'Lecture / talk / reading',
                value: 'Lecture / talk / reading'
            },
            {
                name: 'Exhibition',
                value: 'Exhibition'
            },
            {
                name: 'Performance',
                value: 'Performance'
            },
            {
                name: 'Screening',
                value: 'Screening'
            },
            {
                name: 'Workshop',
                value: 'Workshop'
            },
            {
                name: 'Family Program',
                value: 'Family Program'
            },
            {
                name: 'Tour',
                value: 'Tour'
            },
            {
                name: 'Campus Tour',
                value: 'Campus Tour'
            },
            {
                name: 'Alumni',
                value: 'Alumni'
            }
        ];

        $scope.currentFilters = {program: '', eventtype: ''};
        $scope.clndr = {
            showingEvents: false,
            getNextMonth: function() {
                var nMonth = $scope.clndr.currentMonth.month + 1;
                var year = $scope.clndr.currentMonth.year;
                if (nMonth === 12) {
                    nMonth = 0;
                    year++;
                }

                $scope.clndr.showNewMonth(nMonth, year);
            },
            getPrevMonth: function() {
                var pMonth = $scope.clndr.currentMonth.month - 1;
                var year = $scope.clndr.currentMonth.year;
                if (pMonth < 0) {
                    pMonth = 11;
                    year--;
                }
                $scope.clndr.showNewMonth(pMonth, year);
            },
            getNextDay: function() {
                if (!$scope.clndr.selectedDate) {
                    return false;
                }

                if ($scope.clndr.selectedDate.index >= $scope.clndr.currentMonth.days.length - 1) {
                    $scope.clndr.selectedDate = 1;
                    $scope.clndr.getNextMonth();
                } else {
                    $scope.showDay($scope.clndr.selectedDate.index + 1);
                    //$scope.clndr.selectedDate = $scope.clndr.currentMonth.days[$scope.clndr.selectedDate.index + 1];
                }

            },
            getPrevDay: function() {

                if (!$scope.clndr.selectedDate) {
                    return false;
                }

                if ($scope.clndr.selectedDate.index === 0) {
                    $scope.clndr.selectedDate = -1;
                    $scope.clndr.getPrevMonth();
                } else {
                    $scope.showDay($scope.clndr.selectedDate.index - 1);
                    //$scope.clndr.selectedDate = $scope.clndr.currentMonth.days[$scope.clndr.selectedDate.index - 1];
                }
            },
            showNewMonth: function(m, y) {

                $scope.currentDate = {year: y, month: m, date:false};
                changeURLDate();

                $('#clndr__events__section').detach().appendTo('#clndr__events__holder');
                $scope.clndr.showingEvents = false;
                if ($scope.clndr.selectedDate !== 1 && $scope.clndr.selectedDate !== -1) {
                    $scope.clndr.selectedDate = null;
                }

                $timeout(function() {
                    processMonth(m, y);
                }, 150);
                $('.clndr__grid').eq(0).fadeOut(150, function() {
                    $('.clndr__grid').eq(0).fadeIn(200);
                });
            },
            daysOfTheWeek: [
                'Sun',
                'Mon',
                'Tues',
                'Wed',
                'Thurs',
                'Fri',
                'Sat'
            ],
            daysOfTheWeekLong: [
                'sunday',
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday'
            ],
            monthNames: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            currentMonth: {
                month: 0,
                year: 0,
                days: [],
                daysInMonth: 0
            },
            selectableMonths: [
            ],
            selectedDate: null,
            eventsLocation: null
        };

        $scope.mouseOver = {
            calendarMonth: false,
            calendarDropdown: false
        };

        $scope.showMonthsDropdown = function(bool) {
            $scope.calendarDropdownOpen = bool;

            $timeout(function() {
                if (!$scope.mouseOver.calendarDropdown && !$scope.mouseOver.calendarMonth) {
                    $scope.calendarDropdownOpen = false;
                }
            }, 1500);
        };

        $scope.$watch('currentFilters', function(o1, o2) {
            if (!angular.equals(o1, o2)) {
                getEvents($scope.clndr.currentMonth.days[0].dateObj, $scope.clndr.currentMonth.days[$scope.clndr.currentMonth.days.length - 1].dateObj);
            }
        }, true);

        $scope.showDay = function(dayIndex, showBool) {
            var chosenDate = $scope.clndr.currentMonth.days[dayIndex];
            // figure out which day to insert the events div after
            var indexInsertAfter = (dayIndex%7 === 6) ? dayIndex : dayIndex + 7 - ((dayIndex + 1) % 7) ;

            $scope.currentDate = {year: chosenDate.dateObj.getFullYear(), month: chosenDate.dateObj.getMonth() + 1, date: chosenDate.dateObj.getDate()};
            changeURLDate();

            if ($scope.clndr.currentMonth.days[dayIndex].events.length < 1) {
                // if the date chosen has no events
                if ($scope.clndr.showingEvents) {
                    // if events are showing, slide it up, otherwise do nothing
                    $scope.clndr.showingEvents = false;
                    slidedown.element.slideUp(slidedown.duration);
                    $timeout(function() {
                        $scope.clndr.selectedDate = $scope.clndr.currentMonth.days[dayIndex];
                    }, slidedown.duration);
                } else {
                    $scope.clndr.selectedDate = $scope.clndr.currentMonth.days[dayIndex];
                }
            } else if ($scope.clndr.selectedDate === null || $scope.clndr.selectedDate.stamp !== $scope.clndr.currentMonth.days[dayIndex].stamp || showBool) {
                // a new date is chosen
                if (!$scope.clndr.showingEvents) {
                    // if events aren't showing already, slide down
                    slidedown.element.detach().insertAfter($('.calendar-dom-' + indexInsertAfter));
                    $scope.clndr.selectedDate = $scope.clndr.currentMonth.days[dayIndex];
                    $scope.clndr.showingEvents = true;
                } else if (!showBool) {
                    // slide up the events, then put it elsewhere, then slide it down
                    $scope.clndr.showingEvents = false;
                    slidedown.element.slideUp(slidedown.duration);
                    $timeout(function() {
                        slidedown.element.detach().insertAfter($('.calendar-dom-' + indexInsertAfter));
                        $scope.clndr.selectedDate = $scope.clndr.currentMonth.days[dayIndex];
                        $scope.clndr.showingEvents = true;
                    }, slidedown.duration);
                }
            } else {
                // same date is chosen
                if (!$scope.clndr.showingEvents) {
                    // if events aren't showing already, slide down
                    $scope.clndr.showingEvents = true;
                    slideDownEvents();
                } else {
                    // slide up the events and hide it
                    $scope.clndr.showingEvents = false;
                    slidedown.element.slideUp(slidedown.duration);
                    $timeout(function() {
                        $scope.clndr.selectedDate = $scope.clndr.currentMonth.days[dayIndex];
                    }, slidedown.duration);
                }
            }

        };

        function clearEventsForMonth() {
            for (var i = 0; i < $scope.clndr.currentMonth.days.length; i++) {
                $scope.clndr.currentMonth.days[i].events = [];
            }
            slidedown.element.slideUp(0);
        }

        function hookEventsUpToCalendar(events) {
            var DAY_IN_MS = 86400000;

            var firstDateOfCalendarStamp = $scope.clndr.currentMonth.days[0].stamp;
            var numOfDaysInMonth = $scope.clndr.currentMonth.days.length;

            clearEventsForMonth();

            for (var i = 0; i < events.length; i++) {

                var startIndex =  Math.round((Date.parse(events[i].eventData.startDate) - firstDateOfCalendarStamp) / DAY_IN_MS);  // jshint ignore:line
                var endIndex =  events[i].eventData.endDate ? Math.round((Date.parse(events[i].eventData.endDate) - firstDateOfCalendarStamp) / DAY_IN_MS) : startIndex;  // jshint ignore:line
                var numOfEventDays = endIndex - startIndex + 1;

                // make multiday events show up below single day, 0 will show up higher than 1
                if (numOfEventDays > 1) {
                    events[i].rank = 1;
                } else {
                    events[i].rank = 0;
                }

                if (events[i].image === '') {
                    events[i].image = '/assets/img/default.jpg';
                }

                // loops through days of events and add it to the calendar
                for (var j = 0; j < numOfEventDays; j++) {
                    var currentIndex = j + startIndex;
                    if (currentIndex > -1 && currentIndex < numOfDaysInMonth) {

                        var dw = $scope.clndr.daysOfTheWeekLong[$scope.clndr.currentMonth.days[currentIndex].day];
                        var edw = events[i].eventData.closedDays ? events[i].eventData.closedDays.join() : false;

                        if ((edw && edw.indexOf(dw) === -1) || !edw) {
                            $scope.clndr.currentMonth.days[currentIndex].events.push(events[i]);
                        }
                    }
                }
            }

        }

        function slideDownEvents() {
            var height;

            if (!$scope.clndr.showingEvents) {
                return;
            }

            height = slidedown.element.css('height', 'auto').show().height();
            slidedown.element.hide().css({height: 0});

            slidedown.animating = true;
            slidedown.element.show().animate({height: height}, slidedown.duration, function() {
                slidedown.animating = false;
                fixSlideDownEventsHeight();
            });
        }

        function fixSlideDownEventsHeight() {

            if (!$scope.clndr.showingEvents || slidedown.animating) {
                return;
            }

            slidedown.element.css('height', 'auto');
        }

        // TODO hook this up to the api, to get events for the MONTH
        function getEvents(startDate, endDate) {

            var startDateObj = {};
            var endDateObj = {};
            var queryObj = {};

            startDateObj.date = new Date(startDate);
            startDateObj.day = startDateObj.date.getDate();
            startDateObj.month = startDateObj.date.getMonth() + 1;
            startDateObj.year = startDateObj.date.getFullYear();
            startDateObj.shortString =  startDateObj.year + '-' + startDateObj.month + '-' +  startDateObj.day;

            endDateObj.date = new Date(endDate);
            endDateObj.day = endDateObj.date.getDate();
            endDateObj.month = endDateObj.date.getMonth() + 1;
            endDateObj.year = endDateObj.date.getFullYear();
            endDateObj.shortString =  endDateObj.year + '-' + endDateObj.month + '-' +  endDateObj.day;

            queryObj = {
                category: 'event',
                start: startDateObj.shortString,
                end: endDateObj.shortString,
                program: $scope.currentFilters.program,
                eventtype: $scope.currentFilters.eventtype,
                limit: 10000
            };

            PostFactory.calendarPosts().query(queryObj).$promise.then(function(events) {
                hookEventsUpToCalendar(events);

                if ($scope.currentDate && $scope.clndr.selectedDate) {
                    $scope.showDay($scope.clndr.selectedDate.index, true);
                }
            });

        }

        function daysInMonth(month, year) {
            return new Date(year, month + 1, 0).getDate();
        }

        function getSelectableMonths(month, year) {
            var goMonth;
            var goYear;
            var monthsToShow = 7;   // needs to be odd
            var monthsBeforeAfter = (monthsToShow - 1) / 2;

            $scope.clndr.selectableMonths = [];

            // go back [monthsBeforeAfter] months
            if (month - monthsBeforeAfter < 0) {
                goMonth = 12 + month  - monthsBeforeAfter;
                goYear = year - 1;
            } else {
                goMonth = month - monthsBeforeAfter;
                goYear =  year;
            }

            for (var i = 0; i < monthsToShow; i++) {

                var monthObj = {
                    month: goMonth,
                    year: goYear
                };

                $scope.clndr.selectableMonths.push(monthObj);

                if (goMonth + 1 >= 12) {
                    goMonth = 0;
                    goYear++;
                } else {
                    goMonth++;
                }
            }
        }

        // PROCESS GIVEN MONTH + YEAR (javascript int month + int year)
        function processMonth(month, year, day) {

            var daysInThisMonth = daysInMonth(month, year);
            var firstDateOfMonth = new Date(year, month, 1);
            var firstDayOfMonth = firstDateOfMonth.getDay();
            var lastDateOfMonth = new Date(year, month, daysInThisMonth);
            var lastDayOfMonth = lastDateOfMonth.getDay();
            var arrayIndexCounter = 0;
            var date;
            var i;
            var addToCurrentMonth = function(dateObj, makeSelected) {
                var dateIsCurrent = false;
                if (dateObj.getDate() === today.getDate() && dateObj.getYear() === today.getYear() && dateObj.getMonth() === today.getMonth()) {
                    dateIsCurrent = true;
                }
                $scope.clndr.currentMonth.days.push({
                    dateObj: dateObj,
                    stamp: Date.parse(dateObj),
                    date: dateObj.getDate(),
                    index: arrayIndexCounter,
                    day: dateObj.getDay(),
                    isCurrent: dateIsCurrent,
                    events: []  // to be used with hookEventsUpToCalendar later
                });

                if (makeSelected || (!makeSelected && dateIsCurrent && !$scope.clndr.selectedDate && !$scope.currentDate.day)) {
                    //automatically choose this date if it's the current date
                    $scope.clndr.selectedDate = $scope.clndr.currentMonth.days[arrayIndexCounter];
                }
                arrayIndexCounter++;
            };

            $scope.clndr.currentMonth.month = month;
            $scope.clndr.currentMonth.year = year;
            $scope.clndr.currentMonth.daysInMonth = daysInThisMonth;
            $scope.clndr.currentMonth.days = [];

            // if first day of month is not sunday, get rest of week
            if (firstDayOfMonth !== 0) {
                for (i = 0; i < firstDayOfMonth; i++) {
                    date = new Date(year, month, 1 - (firstDayOfMonth - i));
                    addToCurrentMonth(date);
                }
            }

            for (i = 0; i< $scope.clndr.currentMonth.daysInMonth; i++) {
                date = new Date(year, month, 1 + i);
                if (day && day === (i + 1)) {
                    addToCurrentMonth(date, true);
                } else {
                    addToCurrentMonth(date, false);
                }
            }

            // if last day of month is not saturday, get rest of week
            if (lastDayOfMonth !== 6) {
                for (i = 0; i < 6 - lastDayOfMonth; i++) {
                    date = new Date(year, month + 1, 1 + i);
                    addToCurrentMonth(date);
                }
            }

            // if using arrows to move here
            if ($scope.clndr.selectedDate === -1) {
                $scope.showDay($scope.clndr.currentMonth.days.length - 1);
            } else if ($scope.clndr.selectedDate === 1) {
                $scope.showDay(0);
            }

            getSelectableMonths(month, year);
            getEvents($scope.clndr.currentMonth.days[0].dateObj, $scope.clndr.currentMonth.days[$scope.clndr.currentMonth.days.length - 1].dateObj);
        }

        function getPrograms() {
            PostFactory.programs().query().$promise.then(function(programs) {
                for (var i = 0; i<programs.length; i++) {
                    programs[i].value = programs[i].slug;
                }
                $scope.programFilters = $scope.programFilters.concat(programs);
            });
        }
        getPrograms();

        // PROCESS CURRENT MONTH to start with
        if ($scope.currentDate) {
            //processMonth($scope.currentDate.getMonth(), $scope.currentDate.getFullYear(), $scope.currentDate.getDate());
            processMonth($scope.currentDate.month, $scope.currentDate.year, $scope.currentDate.date);
        } else {
            processMonth(today.getMonth(), today.getFullYear());
        }

        $(document).keydown(function(e) {
            if (e.which === 39) {
                // right arrow
                $scope.$apply($scope.clndr.getNextDay());
            } else if (e.which === 37) {
                // left arrow
                $scope.$apply($scope.clndr.getPrevDay());
            }
        });

        $scope.$on('eventsLoaded', slideDownEvents);
        $scope.$on('eventsImageLoaded', fixSlideDownEventsHeight);
        $scope.$on('app:resized', fixSlideDownEventsHeight);

        $scope.$on('$destroy', function() {
            $(document).unbind('keydown');
        });

        $timeout(function() {
            slidedown.element = $('#clndr__events__section');
            slidedown.element.hide();

            if ($scope.clndr.selectedDate) {
                var dayIndex = $scope.clndr.selectedDate.index;
                var indexInsertAfter = (dayIndex%7 === 6) ? dayIndex : dayIndex + 7 - ((dayIndex + 1) % 7) ;
                slidedown.element.detach().insertAfter($('.calendar-dom-' + indexInsertAfter));
            }
        });

    }])
;
